import script from "./DefaultAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultAlert.vue?vue&type=script&setup=true&lang=js"

import "./DefaultAlert.vue?vue&type=style&index=0&id=b400a14c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b400a14c"]])

export default __exports__